import type { ILogDto } from 'dtos/logs.dto';
import { BackendGateway } from 'gateway/backend.gateway';
import type { IVisit } from 'types/visit.type';

export class VisitRepository {
  private static _instance: VisitRepository | undefined;
  readonly VISIT_DURATION_MS = 3600 * 1000; // 1 hour

  private constructor(readonly backend: BackendGateway) {}

  static getInstance(backend: BackendGateway = BackendGateway.getInstance()): VisitRepository {
    this._instance ??= new this(backend);
    return this._instance;
  }

  async log(item: ILogDto): Promise<void> {
    const visit = await this.getVisit();

    const response = await this.backend.call({
      uri: 'log',
      method: 'POST',
      data: { ...item, v: visit.visitId },
    });

    if (response.ok) {
      console.log('Log sent', { ...item, v: visit.visitId });
      return;
    }

    console.error('Session could not be initialized', response.error);
  }

  private async getVisit(): Promise<IVisit> {
    const cachedVisitStr = localStorage.getItem('visit');
    let cachedVisit: IVisit | undefined = cachedVisitStr ? JSON.parse(cachedVisitStr) : undefined;
    if (cachedVisit && Date.now() - cachedVisit.lastUpdateTime > this.VISIT_DURATION_MS) {
      cachedVisit = undefined;
    }

    const visit: IVisit = cachedVisit ?? {
      visitId: this.generateVisitId(),
      creationTime: Date.now(),
      lastUpdateTime: Date.now(),
    };
    visit.lastUpdateTime = Date.now();

    localStorage.setItem('visit', JSON.stringify(visit));
    return visit;
  }

  private generateVisitId(): string {
    return new Date().toISOString().replace(/[:.]/g, '-') + '_' + Math.random().toString(36).substring(2, 10);
  }
}
